import { createContext } from 'react';

const CurrentOrgContext = createContext({
  _id: '',
  features: {},
  logo: '',
  name: '',
  path: '',
  settings: {},
  Users: [],
});

export const CurrentOrgProvider = CurrentOrgContext.Provider;
export const CurrentOrgConsumer = CurrentOrgContext.Consumer;
export default CurrentOrgContext;
